import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Linkedin, Send, CheckCircle2 } from 'lucide-react';
const inquiryTypes = ['Executive Opportunities', 'Board Opportunities', 'Advisory Roles', 'Speaking Engagements', 'Consulting Opportunities', 'Media Requests'];
export function Contact() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  useEffect(() => {
    document.title = 'Contact | Michelle McOmber Healthcare Executive';
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus('submitting');
    setTimeout(() => setFormStatus('success'), 1000);
  };
  return <div className="w-full bg-white" data-id="element-185">
      <header className="bg-navy-900 text-white py-20" data-id="element-186">
        <div className="max-w-7xl mx-auto px-6" data-id="element-187">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-188">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-189">
              Contact the Office
            </h1>
            <p className="text-xl text-slate-300 max-w-2xl" data-id="element-190">
              For executive, board, advisory, speaking, and media inquiries.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="py-20" data-id="element-191">
        <div className="max-w-7xl mx-auto px-6" data-id="element-192">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-16" data-id="element-193">
            <div className="lg:col-span-1 space-y-10" data-id="element-194">
              <div data-id="element-195">
                <h2 className="text-2xl font-serif font-bold text-navy-900 mb-6" data-id="element-196">
                  Contact Information
                </h2>
                <div className="space-y-6" data-id="element-197">
                  <div className="flex items-start" data-id="element-198">
                    <MapPin className="w-6 h-6 text-gold mr-4 shrink-0 mt-1" data-id="element-199" />
                    <div data-id="element-200">
                      <p className="font-bold text-navy-900" data-id="element-201">Location</p>
                      <p className="text-slate-600" data-id="element-202">Salt Lake City, Utah</p>
                      <p className="text-slate-500 text-sm" data-id="element-203">
                        Available for national opportunities
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-204">
                    <Mail className="w-6 h-6 text-gold mr-4 shrink-0 mt-1" data-id="element-205" />
                    <div data-id="element-206">
                      <p className="font-bold text-navy-900" data-id="element-207">Email</p>
                      <a href="mailto:michelle@mcomber.example" className="text-slate-600 hover:text-gold transition-colors" data-id="element-208">
                        michelle@mcomber.example
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-209">
                    <Phone className="w-6 h-6 text-gold mr-4 shrink-0 mt-1" data-id="element-210" />
                    <div data-id="element-211">
                      <p className="font-bold text-navy-900" data-id="element-212">Phone</p>
                      <p className="text-slate-600" data-id="element-213">(801) 555-0198</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-8 border-t border-slate-200" data-id="element-214">
                <h2 className="text-xl font-serif font-bold text-navy-900 mb-4" data-id="element-215">
                  Professional Network
                </h2>
                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-slate-600 hover:text-navy-900 transition-colors" data-id="element-216">
                  <Linkedin className="w-5 h-5 mr-2 text-gold" data-id="element-217" />
                  Connect on LinkedIn
                </a>
              </div>
            </div>

            <div className="lg:col-span-2" data-id="element-218">
              <div className="bg-slate-50 rounded-xl p-8 md:p-10" data-id="element-219">
                <h2 className="text-2xl font-serif font-bold text-navy-900 mb-6" data-id="element-220">
                  Executive Inquiry
                </h2>
                {formStatus === 'success' ? <div className="text-center py-12" data-id="element-221">
                    <CheckCircle2 className="w-14 h-14 text-gold mx-auto mb-4" data-id="element-222" />
                    <p className="text-navy-900 font-bold text-xl mb-2" data-id="element-223">
                      Thank you for reaching out.
                    </p>
                    <p className="text-slate-600" data-id="element-224">
                      Michelle&rsquo;s office will respond within two business
                      days.
                    </p>
                  </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-225">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-226">
                      <input required placeholder="Name" className="w-full border border-slate-200 rounded px-4 py-3 bg-white" data-id="element-227" />
                      <input required placeholder="Organization" className="w-full border border-slate-200 rounded px-4 py-3 bg-white" data-id="element-228" />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-229">
                      <input required type="email" placeholder="Email" className="w-full border border-slate-200 rounded px-4 py-3 bg-white" data-id="element-230" />
                      <input type="tel" placeholder="Phone" className="w-full border border-slate-200 rounded px-4 py-3 bg-white" data-id="element-231" />
                    </div>
                    <select required defaultValue="" className="w-full border border-slate-200 rounded px-4 py-3 bg-white text-slate-700" data-id="element-232">
                      <option value="" disabled data-id="element-233">
                        Select inquiry type
                      </option>
                      {inquiryTypes.map(t => <option key={t} value={t} data-id="element-234">
                          {t}
                        </option>)}
                    </select>
                    <textarea required placeholder="Message" rows={5} className="w-full border border-slate-200 rounded px-4 py-3 bg-white" data-id="element-235" />
                    <button type="submit" disabled={formStatus === 'submitting'} className="bg-navy-900 hover:bg-navy-800 text-white px-8 py-4 font-medium transition-colors flex items-center justify-center disabled:opacity-60" data-id="element-236">
                      {formStatus === 'submitting' ? 'Sending…' : 'Send Inquiry'}
                      <Send className="w-4 h-4 ml-2" data-id="element-237" />
                    </button>
                  </form>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}